<!-- Translated: yes -->
<template>
  <div :class="'icon icon--' + className" :style="'width:' + scale + 'em;height:' + scale + 'em;'" :aria-hidden="ariaHidden ? 'true' : 'false'">
    <img :src="'https://static.booking.branasgruppen.se/static/svg/' + name + '.svg'" :style="'width:' + scale + 'em;height:' + scale + 'em;'"  :aria-hidden="ariaHidden ? 'true' : 'false'" :alt="altText" />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      default: '',
    },
    scale: {
      default: 1,
    },
    ariaHidden: {
      default: true,
    },
    alt: {
      default: '',
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    className() {
      return this.name.replace(/ /g, '-').replace(/[^A-Za-z0-9-]/g, '');
    },
    altText() {
      return this.alt || `Illustration av ${this.name.replace(/-/g, ' ')}`;
    },
  },
};
</script>

<style lang="stylus" scoped>
.icon
  display inline-block
  vertical-align middle
  height 1em
  width 1em
  max-width none
  min-width 0
  max-height none
  min-height 0
  line-height 0em

  img
    width 1em
    height 1em
    max-width none
    min-width 0
    max-height none
    min-height 0
    vertical-align middle
</style>



// WEBPACK FOOTER //
// Icon.vue?48b13fd9